module.exports = __webpack_public_path__ + "img/logo.f507d54e.png";